import { Component, Input } from "@angular/core";

@Component({
  selector: "app-page-header",
  standalone: true,
  templateUrl: "./PageHeaderComponent.html",
  styleUrl: "./PageHeaderComponent.scss",
})
export class PageHeaderComponent {
  @Input() title = "";
  @Input() subtitle?: string;
  @Input() eyebrow?: string;
}
